(function () {
  'use strict';

  function MatchHeight(targets, opts) {
    if (!targets) throw new Error('Missing selector 😢');

    opts = opts || {};

    let debounceTimer;
    let elements;
    let maxHeight = 0;
    let defaults = {
      timeout: 100,
      cssProperty: 'minHeight',
      mediaQuery: '(min-width: 0px)',
    };

    opts = util.deepExtend(defaults, opts);
    const mq = window.matchMedia(opts.mediaQuery);

    // debounce
    function debounceReset() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        reset();
      }, opts.timeout);
    }

    // reset
    function reset() {
      maxHeight = 0;

      elements.forEach((el) => {
        el.style.height = 'auto';
        el.style.minHeight = '0';
        maxHeight = Math.max(maxHeight, el.clientHeight);
      });

      if (mq.matches) {
        if (isNaN(maxHeight) === false && maxHeight > 0) {
          elements.forEach((el) => {
            if (opts.cssProperty === 'height') {
              el.style.height = maxHeight + 'px';
            } else {
              el.style.minHeight = maxHeight + 'px';
            }
          });
        }
      }
    }

    if (typeof targets === 'string') {
      elements = Array.prototype.slice.call(document.querySelectorAll(targets));
    } else if (typeof targets === 'object') {
      elements = Array.prototype.slice.call(targets);
    }

    reset();

    window.addEventListener(
      'resize',
      function () {
        debounceReset();
      },
      { passive: true }
    );

    return {
      reset: reset,
    };
  }

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = MatchHeight;
  } else {
    window.MatchHeight = MatchHeight;
  }
})();
